import React from 'react';
import { 
  HelpCircle, 
  DollarSign, 
  Clock, 
  Percent, 
  FileText, 
  Shield, 
  Zap, 
  Landmark,
  ArrowRightLeft
} from 'lucide-react';

/**
 * Компонент с советами по рефинансированию кредита
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: ArrowRightLeft,
      title: 'Когда рефинансировать',
      description: 'Рефинансирование выгодно, если новая ставка ниже текущей минимум на 1-2 процентных пункта.'
    },
    {
      icon: Clock,
      title: 'Оставшийся срок',
      description: 'Наиболее выгодно рефинансировать, когда до конца срока текущего кредита осталось не менее года.'
    },
    {
      icon: Percent,
      title: 'Снижение ставки',
      description: 'Даже незначительное снижение ставки (на 0.5-1%) может дать ощутимую экономию на длительном сроке.'
    },
    {
      icon: FileText,
      title: 'Документы',
      description: 'Подготовьте паспорт, справку о доходах, выписку по текущему кредиту и кредитный договор.'
    },
    {
      icon: Shield,
      title: 'Страхование',
      description: 'Страховка часто обязательна, но может снизить ставку. Сравните варианты со страховкой и без.'
    },
    {
      icon: Zap,
      title: 'Досрочное погашение',
      description: 'Узнайте условия досрочного погашения нового кредита. Это поможет сэкономить еще больше.'
    },
    {
      icon: Landmark,
      title: 'Выбор банка',
      description: 'Проверьте несколько банков – иногда условия могут существенно отличаться.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по рефинансированию
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <DollarSign className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Помощь с рефинансированием
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Наши партнеры помогут подобрать оптимальное предложение по рефинансированию в вашем регионе.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Найти кредитного брокера
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;